export const FIELD_TEMPLATES = {
  services: { name: { fr: "", en: "" }, desc: { fr: "", en: "" }, status: "inclus", icon: "sparkles" },
  team: { name: { fr: "", en: "" }, role: { fr: "", en: "" }, bio: { fr: "", en: "" }, image: "", photo_authorized: false },
  rooms: { name: { fr: "", en: "" }, desc: { fr: "", en: "" }, price: "", availability: { fr: "", en: "" }, image: "" },
  availability: { room_type: { fr: "", en: "" }, status: { fr: "", en: "" }, note: { fr: "", en: "" } },
  testimonials: { author: "", detail: { fr: "", en: "" }, quote: { fr: "", en: "" }, authorized: false, published: true },
  faq: { q: { fr: "", en: "" }, a: { fr: "", en: "" } },
  jobs: { title: { fr: "", en: "" }, type: { fr: "", en: "" }, desc: { fr: "", en: "" } },
  gallery: { caption: { fr: "", en: "" }, image: "", photo_authorized: false },
  cookie_inventory: { name: { fr: "", en: "" }, category: "necessaire", purpose: { fr: "", en: "" }, duration: { fr: "", en: "" }, provider: { fr: "", en: "" } },
};

export const STATUS_OPTIONS = ["inclus", "offert", "supplement", "sur_evaluation", "non_offert"];

export const SECTIONS = [
  { key: "settings", label: "Coordonnées & textes", singleton: true },
  { key: "services", label: "Services" },
  { key: "team", label: "Équipe" },
  { key: "rooms", label: "Chambres" },
  { key: "availability", label: "Disponibilités" },
  { key: "testimonials", label: "Témoignages" },
  { key: "faq", label: "FAQ" },
  { key: "jobs", label: "Emplois" },
  { key: "gallery", label: "Galerie" },
  { key: "cookie_inventory", label: "Inventaire des témoins" },
  { key: "policies", label: "Politiques & version", singleton: true },
  { key: "submissions", label: "Soumissions", special: "submissions" },
  { key: "consent", label: "Preuves de consentement", special: "consent" },
  { key: "audit", label: "Journal d'audit", special: "audit" },
];
